module.exports = BN;